import { j as o } from "../../../node_modules/react/jsx-runtime.js";
import { useFloating as B, FloatingFocusManager as U, FloatingPortal as q } from "../../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { clsx as N } from "../../../node_modules/clsx/dist/clsx.m.js";
import { useState as v, useRef as G, useEffect as J } from "react";
import { i18n as g } from "../../../utils/locale/locale.js";
import K from "../Button/Button.js";
import L from "../DatePicker/useOnClickOutside.js";
import j from "./TimePicker.module.scss.js";
import d from "./TimePickerColumns.js";
import { offset as Q } from "../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { autoUpdate as V } from "../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import { setHours as y } from "../../../node_modules/date-fns/setHours.js";
import { setMinutes as W } from "../../../node_modules/date-fns/setMinutes.js";
import { parse as X } from "../../../node_modules/date-fns/parse.js";
import { formatDate as m } from "../../../node_modules/date-fns/format.js";
const de = ({
  initialTime: c = /* @__PURE__ */ new Date(),
  type: S = "digital",
  openTimePicker: D = !1,
  position: b = "bottom-start",
  hasTrigger: F = !0,
  onTimeChange: s,
  withPortal: n,
  disabledItems: u,
  maxTime: h,
  minTime: M,
  disableCloseOut: H = !1
}) => {
  const [t, l] = v(c), [i, p] = v(D), x = G(null), { refs: k, context: P, floatingStyles: I } = B({
    open: i,
    onOpenChange: p,
    placement: b,
    middleware: [Q(10)],
    whileElementsMounted: V
  });
  L(x, () => {
    H || p(!1);
  });
  const _ = (r) => {
    const e = y(t, Number(r));
    l(e), s == null || s(e);
  }, $ = (r) => {
    const e = W(t, Number(r));
    l(e), s == null || s(e);
  };
  J(() => {
    (typeof c == "string" || (c == null ? void 0 : c.getTime()) !== (t == null ? void 0 : t.getTime())) && l(c);
  }, [c]);
  const E = (r) => {
    const e = t.getHours(), a = r === "AM" ? e >= 12 ? e - 12 : e : e < 12 ? e + 12 : e, A = y(t, a);
    l(A), s == null || s(A);
  }, R = (r) => {
    const e = X(r.toString(), "hh:mm a", /* @__PURE__ */ new Date());
    l(e), s == null || s(e, r);
  }, w = Array.from({ length: 12 }, (r, e) => String(e + 1).padStart(2, "0")), z = Array.from({ length: 60 }, (r, e) => String(e).padStart(2, "0")), f = Array.from({ length: 24 }, (r, e) => [
    `${(e % 12 || 12).toString().padStart(2, "0")}:00 ${e < 12 ? "AM" : "PM"}`,
    `${(e % 12 || 12).toString().padStart(2, "0")}:30 ${e < 12 ? "AM" : "PM"}`
  ]).flat(), O = () => {
    const r = (e) => {
      const a = f.indexOf(e);
      return h && a > f.indexOf(h) || M && a < f.indexOf(M) ? !0 : (u == null ? void 0 : u.includes(e)) || !1;
    };
    return /* @__PURE__ */ o.jsx(
      "div",
      {
        ref: n ? k.setFloating : null,
        style: n ? I : {},
        className: j.timePickerContainer,
        children: S === "multiSection" ? /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: N(n ? j.timePickerColumn : "grid grid-cols-3"),
            ref: x,
            children: [
              /* @__PURE__ */ o.jsx(
                d,
                {
                  header: g("hours"),
                  items: w,
                  withPortal: n,
                  selected: m(t, "hh"),
                  onItemChange: _
                }
              ),
              /* @__PURE__ */ o.jsx(
                d,
                {
                  header: g("mins"),
                  items: z,
                  withPortal: n,
                  selected: m(t, "mm"),
                  onItemChange: $
                }
              ),
              /* @__PURE__ */ o.jsx(
                d,
                {
                  header: g("am_pm"),
                  items: ["AM", "PM"],
                  selected: m(t, "a"),
                  withPortal: n,
                  onItemChange: E
                }
              )
            ]
          }
        ) : /* @__PURE__ */ o.jsx(
          "div",
          {
            className: N(
              j.timePickerColumn,
              "border-[1px] border-solid border-color-border-lightest rounded-small"
            ),
            ref: x,
            children: /* @__PURE__ */ o.jsx(
              d,
              {
                items: f,
                isDisabledItem: r,
                selected: t instanceof Date ? m(t, "hh:mm a") : t,
                digital: S === "digital",
                withPortal: n,
                onItemChange: R
              }
            )
          }
        )
      }
    );
  };
  return /* @__PURE__ */ o.jsxs("div", { className: "flex flex-col gap-300", children: [
    F && /* @__PURE__ */ o.jsx(
      "div",
      {
        className: "w-fit",
        ref: n ? k.setReference : null,
        children: /* @__PURE__ */ o.jsx(
          K,
          {
            variant: "outlined",
            color: "neutral",
            size: "medium",
            label: t instanceof Date ? m(t, "hh:mm a") : t,
            leadingIcon: "calendar",
            onClick: () => p(!i)
          }
        )
      }
    ),
    i && /* @__PURE__ */ o.jsx(U, { context: P, children: n ? /* @__PURE__ */ o.jsx(q, { children: O() }) : O() })
  ] });
};
export {
  de as default
};
//# sourceMappingURL=TimePicker.js.map
